<template lang="pug">
.menu(:key="key")
    tabs(:items="tabs" :active-tab="activeTab" @click="activateTab")
        //- template(slot="tabbar-buttons")
        //-     .actions(v-if="!(error && [401, 403].includes(error.code))" )
        //-         el-button.settings-button(
        //-             circle v-if="! loading && effectiveExtensions.includes('restricted-area')"
        //-             type="info"
        //-             icon="el-icon-fa-cogs fas"
        //-             :disabled="isDisabledSubmit"
        //-             @click="openSettingsModal"
        //-         )
        //-         el-button(
        //-             circle v-if="! loading"
        //-             type="success"
        //-             icon="el-icon-fa-save fas"
        //-             :disabled="isDisabledSubmit && ! saving"
        //-             :loading="saving"
        //-             @click="submit"
        //-         )

    el-form(label-position="top" :model="form" :rules="rules" ref="form")
        el-card(shadow="always" v-loading="loading")
            .error(v-if="notFound")
                Error(:message="$t('Menu Not Found')")
            .error(v-else-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .empty-menu(v-else-if="! tree.length")
                el-alert(type="info" :title="$t('This menu has no items yet')" :closable="false")
                .flex-row(v-if="!loading")
                    .buttons
                        el-button.add-first-item(
                            type="primary"
                            :class="{ 'full-width': !effectiveExtensions.includes('restricted-area') }"
                            icon="el-icon-fa-plus fas"
                            @click="openNewItemModal"
                        ) {{ $t('Add Menu Item') }}
                    template(v-if="effectiveExtensions.includes('restricted-area')")
                        .grow
                        .buttons
                            el-button.settings-button(
                                type="info"
                                icon="el-icon-fa-cogs fas"
                                :disabled="isDisabledSubmit"
                                @click="openSettingsModal"
                            ) {{ $t('Settings') }}
            .menu-items(v-else)
                .tree(
                    ref="tree"
                    :class="{ 'no-collapsables': !collapsables.length }"
                    :style="{ flexBasis: treeWidth + 'px', width: treeWidth + 'px' }"
                )
                    .context-icon
                        i.el-icon-fa-bars.fas
                        //- small {{ $t('Menu items') }}
                        small {{ form.name }}
                    .flex-row(v-if="!loading")
                        .buttons(:class="{ grow: !effectiveExtensions.includes('restricted-area') }")
                            el-button.add-item(
                                :class="{ 'full-width': !effectiveExtensions.includes('restricted-area') }"
                                type="primary"
                                size="small"
                                icon="el-icon-fa-plus fas"
                                @click="openNewItemModal"
                            ) {{ $t('Add Menu Item') }}
                        template(v-if="effectiveExtensions.includes('restricted-area')")
                            .grow
                            .buttons
                                el-button.settings-button(
                                    circle
                                    size="small"
                                    type="info"
                                    icon="el-icon-fa-cogs fas"
                                    :disabled="isDisabledSubmit"
                                    @click="openSettingsModal"
                                )
                    el-button-group(v-if="collapsables.length")
                        el-button.expand-all(
                            @click="forceExpandAll"
                            :type="ui.expandAll ? 'primary' : 'default'"
                            size="mini"
                        ) {{ $t('Expand all') }}
                        el-button.collapse-all(
                            @click="forceCollapseAll"
                            :type="ui.expandAll ? 'default' : 'primary'"
                            size="mini"
                        ) {{ $t('Collapse all') }}

                    //- Items

                    el-tree(
                        :key="`${currentItem ? currentItem.id : 'new'}-${uniqid}-${ui.expandAll}`"
                        :data="tree"
                        :props="treeProps"
                        :default-expand-all="ui.expandAll"
                        :expand-on-click-node="false"
                        :default-expanded-keys="expandedKeys"
                        :current-node-key="currentItem ? currentItem.id : null"
                        :highlight-current="true"
                        :check-on-click-node="false"
                        :show-checkbox="false"
                        :check-strictly="true"
                        :empty-text="$t('This menu has no items yet')"
                        node-key="id"
                        :allow-drag="isDraggable"
                        @current-change="changeCurrentItem"
                        @node-drop="moveMenuItem"
                        draggable
                    )
                        span.custom-tree-node.el-tree-node__label(
                            slot-scope="{ node, data: item }"
                            :class="{ disabled: item.disabled || hasDisabledAncestor(item), orphan: isOrphan(item) }"
                        )
                            span.buttons.before
                                el-button.info.expandable(
                                    v-if="node.childNodes && node.childNodes.length"
                                    size="mini"
                                    type="text"
                                    @click.stop="toggleExpand(node)"
                                )
                                    //- .el-icon-fa-check-circle.far
                                    i(v-if="!collapsables.includes(item.id)")
                                    i(v-else-if="node.expanded").el-icon-fa-chevron-down.fas
                                    i(v-else).el-icon-fa-chevron-right.fas

                            span.icon.homepage(v-if="node.data.homepage" :class="{ restricted: node.data.homepage_restriction }")
                                template(v-if="node.data.homepage_restriction")
                                    i.el-icon-fa-house-circle-exclamation.fas
                                template(v-else)
                                    i.el-icon-fa-house-chimney.fas
                            span.icon.folder(v-else-if="node.childNodes && node.childNodes.length")
                                template(v-if="['members', 'member-tags'].includes(node.data.restriction)")
                                    i.el-icon-fa-portrait.fas
                                template(v-else-if="node.data.restriction === 'guests'")
                                    i.el-icon-fa-id-badge.far
                                template(v-else)
                                    i.el-icon-fa-folder.fas
                            span.icon.file(v-else)
                                template(v-if="['members', 'member-tags'].includes(node.data.restriction)")
                                    i.el-icon-fa-portrait.fas
                                template(v-else-if="node.data.restriction === 'guests'")
                                    i.el-icon-fa-id-badge.far
                                template(v-else)
                                    i.el-icon-fa-file-alt.fas

                            component.grow(
                                :is="item.deleted ? 'strike' : 'span'"
                                :title="item.translationOrigin ? item.translationOrigin.title : item.title"
                            )
                                | {{ item.translationOrigin ? item.translationOrigin.title : item.title }}

                            span(:class="{ hidden: !staging }") {{ item._lft }} {{ item._rgt }}
                            span.buttons.after
                                template(v-if="isDeletable(item)")
                                    el-tooltip(v-if="item.hidden" effect="dark" :content="$t('Show')" placement="top")
                                        el-button.info.toggle-visibility(
                                            size="mini"
                                            type="text"
                                            @click.stop="unhideItem(item)"
                                        )
                                            i.el-icon-fa-eye-slash.far
                                    el-tooltip(v-else effect="dark" :content="$t('Hide')" placement="top")
                                        el-button.primary.toggle-visibility(
                                            size="mini"
                                            type="text"
                                            @click.stop="hideItem(item)"
                                        )
                                            i.el-icon-fa-eye.far
                                    //- template(v-if="item.deleted")
                                    //-     el-button.success(
                                    //-         size="mini"
                                    //-         type="text"
                                    //-         @click.stop="restoreItem(item)"
                                    //-     )
                                    //-         i.el-icon-fa-trash-restore.fas
                                    //- template(v-else-if="hasDeletedAncestor(item)")
                                    //-     el-button.info(
                                    //-         size="mini"
                                    //-         type="text"
                                    //-         disabled
                                    //-     )
                                    //-         i.el-icon-fa-trash-alt.far
                                    //- template(v-else)
                                    template
                                        el-tooltip(effect="dark" :content="$t('Duplicate')" placement="top")
                                            el-button.info.duplicate(
                                                size="mini"
                                                type="text"
                                                @click.stop="openDuplicateDialog(item)"
                                            )
                                                i.el-icon-fa-clone.fas
                                        el-tooltip(effect="dark" :content="$t('Delete')" placement="top")
                                            el-button.danger(
                                                size="mini"
                                                type="text"
                                                @click.stop="openDeleteDialog(item)"
                                            )
                                                i.el-icon-fa-trash-alt.fas

                //- .content#sticky-content-container(ref="content")
                //-     affix.sticky-stuff(
                //-         relative-element-selector="#sticky-content-container"
                //-         :offset="{ top: 0, bottom: 0 }"
                //-         :scroll-affix="true"
                //-         :style="[ contentWidth ? { width: `${contentWidth}px` } : null ]"
                //-     )
                //-         router-view.menu-item-form(v-if="currentItem" :key="$route.params.id" :class="{'loading-panel': loading}")
                //-         el-alert(v-else type="info" :title="$t('No menu item selected!')" :closable="false")

                //- Drag the grip to make the tree column wider/narrower; double-click resets it.
                //- The grip stays centered in the viewport (sticky) so it is always discoverable.
                .tree-resize-handle(
                    ref="treeResizeHandle"
                    :class="{ 'tree-resize-handle--active': treeResize }"
                    :title="$t('Drag to resize, double-click to reset')"
                    @mousedown="startTreeResize"
                    @dblclick="resetTreeWidth"
                )
                    span.tree-resize-handle__grip(
                        ref="treeGrip"
                        v-show="treeGripLeft > 0"
                        :style="{ left: treeGripLeft + 'px', top: treeGripTop + 'px' }"
                        @mousedown.stop="startTreeResize"
                        @dblclick.stop="resetTreeWidth"
                    )
                        i.el-icon-fa-grip-lines-vertical.fas

                .content
                    router-view.menu-item-form(v-if="currentItem" :key="$route.path" :class="{'loading-panel': loading}")
                    el-alert(v-else type="info" :title="$t('No menu item selected!')" :closable="false")

        //- .buttons-flex
        //-     .form-buttons
        //-         el-button.settings-button(
        //-             round v-if="! loading && effectiveExtensions.includes('restricted-area')"
        //-             type="info"
        //-             icon="el-icon-fa-cogs fas"
        //-             :disabled="isDisabledSubmit"
        //-             @click="openSettingsModal"
        //-         ) {{ $t('Settings') }}
        //-     .form-buttons(v-if="!(error && [401, 403].includes(error.code))")
        //-         el-button(
        //-             round v-if="! loading"
        //-             type="success"
        //-             icon="el-icon-fa-save fas"
        //-             :loading="saving"
        //-             :disabled="isDisabledSubmit && ! saving"
        //-             @click="submit"
        //-         ) {{ $t('Save') }}

        .buttons-flex
            .form-buttons
            .form-buttons
                el-button.preview-button(
                    round plain
                    v-if="canShowPreview"
                    type="link"
                    icon="el-icon-fa-eye far"
                    @click="showPreviewModal"
                )
                    | {{ $t('Preview') }}
                    kbd.shortcut-hint {{ previewShortcut }}

    PreviewDrawer(
        :visible.sync="previewDrawer.visibility"
        :src="previewDrawer.src"
        :loading="previewDrawer.loading"
        @closed="resetPreviewModal"
    )

    el-dialog.new-page-dialog(
        :title="$t('Add new page')"
        :visible.sync="newItemDialog.visibility"
        :before-close="confirmDiscard(() => changedSince(newItemDialog.formSnapshot, newItemDialog.form))"
        :close-on-click-modal="false"
        top="10vh"
        width="620px"
        @closed="resetNewItemModal"
    )
        el-form.property-modal-form(
            ref="newItemForm"
            :model="newItemDialog.form"
            label-position="top"
            :rules="newItemRules"
            v-loading="newItemDialog.loading"
            @submit.prevent.native="addMenuItem"
        )
            //- transition(name="slide-vertical")
                .modal-body(v-if="! newItemDialog.loading")
            .modal-body
                el-row.no-margin(:gutter="20")
                    el-col(:sm="12")
                        el-form-item(:label="$t('Name')" prop="item.title")
                            el-input(v-model="newItemDialog.form.item.title" autocomplete="off" v-focus maxlength="255" show-word-limit)
                    el-col(:sm="12")
                        template(v-if="newItemDialog.form.item.key === 'Redirect'")
                            el-form-item(:label="$t('URL')" prop="item.redirect")
                                el-input(v-model="newItemDialog.form.item.redirect" autocomplete="off" maxlength="255" show-word-limit)
                                    // template(slot="prepend") http(s)://
                        template(v-else)
                            el-form-item(:label="$t('URL Key')" prop="item.path")
                                el-input(v-model="newItemDialog.form.item.path" autocomplete="off" maxlength="255" show-word-limit)
                                    // template(slot="prepend") /
                //- The domain root is not a URL key of its own - it is served by
                //- whichever page carries this flag. No form-item label: the switch
                //- names itself, and an empty label would render a blank label row.
                el-form-item(v-if="newItemDialog.form.item.key !== 'Redirect'")
                    el-switch(
                        :active-text="$t('Start page')"
                        v-model="newItemDialog.form.item.homepage"
                    )
                    .new-item-dialog__help(v-if="storeHasHomepage") {{ $t('Replaces the current start page.') }}
                    .new-item-dialog__help(v-else) {{ $t('Without a start page, visitors get an error page.') }}
                el-form-item(:label="$t('Type')" prop="item.component.view")
                    el-select.is-full-width(
                        placeholder="" v-model="newItemDialog.form.item.component" valueKey="view"
                        :class="{ 'loading': menuOptions.itemType.loading }"
                    )
                        el-option(
                            v-for="(item, key) in menuOptions.itemType.items" :key="key"
                            v-if="! item.hidden" :label="$t(item.name)" :value="item"
                        )
                el-form-item(v-if="tree.length" :label="$t('Position')" prop="position")
                    .target-position
                        .position
                            el-switch(
                                active-color="$--color-primary"
                                inactive-color="$--color-primary"
                                :active-text="$t('into')"
                                :inactive-text="$t('under')"
                                active-value="into"
                                inactive-value="after"
                                v-model="newItemDialog.form.position"
                            )
                        .target
                            Treeselect(
                                v-model="newItemDialog.form.target"
                                placeholder=""
                                :multiple="false"
                                :options="tree"
                                :default-expand-level="ui.expandAll ? Infinity : 0"
                                :close-on-select="true"
                                :open-on-focus="true"
                                :searchable="false"
                                :clearable="false"
                                :always-open="false"
                            )
                                label(
                                    slot="option-label"
                                    slot-scope="{ node }"
                                ) {{ node.raw.title }}
                                div(
                                    slot="value-label"
                                    slot-scope="{ node }"
                                ) {{ node.raw.title }}
                el-form-item(:label="$t('Copy content from')")
                    Treeselect(
                        v-model="newItemDialog.form.sourceMenuItemId"
                        placeholder=""
                        :multiple="false"
                        :options="allMenuItemsForCloning"
                        :default-expand-level="Infinity"
                        :close-on-select="true"
                        :open-on-focus="true"
                        :searchable="true"
                        :normalizer="function (node) { return { label: node.title, id: node.id, children: node.children, isDisabled: node.isDisabled } }"
                        :clearable="true"
                        :always-open="false"
                    )
                        label(
                            slot="option-label"
                            slot-scope="{ node }"
                            :class="{ optgroup: node.raw.optgroup }"
                        )
                            span {{ node.raw.title }}
                        div(
                            slot="value-label"
                            slot-scope="{ node }"
                        )
                            span {{ node.raw.title }}
        template(slot="footer")
            el-button(
                size="mini"
                icon="el-icon-fa-times fas"
                @click="closeNewItemModal"
            ) {{ $t('Dismiss') }}
            el-button(
                :disabled="newItemDialog.loading"
                size="mini"
                type="primary"
                icon="el-icon-fa-check fas"
                @click="addMenuItem"
            ) {{ $t('Create Menu Item') }}

    el-dialog.settings-dialog(
        :title="$t('Settings')"
        :visible.sync="settingsDialog.visibility"
        :before-close="confirmDiscard(() => changedSince(settingsDialog.formSnapshot, settingsDialog.form))"
        :close-on-click-modal="false"
        top="10vh"
        width="620px"
        @closed="resetNewItemModal"
    )
        el-form.property-modal-form(
            ref="settingsForm"
            :model="settingsDialog.form"
            label-position="top"
            :rules="settingsRules"
            v-loading="settingsDialog.loading"
            @submit.prevent.native="updateSettings"
        )
            .modal-body
                el-form-item(:label="$t('Name')" prop="name")
                    el-input(v-model="settingsDialog.form.name" autocomplete="off" maxlength="255" show-word-limit)
                .flex-row
                    el-form-item.grow(:label="$t('Accessible by')" prop="restriction")
                        el-select.is-full-width(placeholder="" v-model="settingsDialog.form.restriction")
                            el-option(
                                v-for="restriction in restrictions"
                                :key="restriction.key"
                                :label="restriction.name"
                                :value="restriction.value"
                            )
                    transition(name="slide-decent-left")
                        el-form-item(v-if="['members', 'member-tags'].includes(settingsDialog.form.restriction)" label=" ")
                            el-switch(
                                :active-text="$t('Any')"
                                :value="settingsDialog.form.restriction === 'members'"
                                @change="toggleSettingsDialogMemberRestriction"
                            )
                transition(name="slide-decent-vertical")
                    el-form-item(
                        v-if="settingsDialog.form.restriction === 'member-tags'"
                        :label="$t('Only members with the following tags can access this menu')"
                        prop="tags"
                    )
                        el-select.is-full-width(
                            ref="memberTagSelect"
                            multiple
                            clearable
                            filterable
                            allow-create
                            default-first-option
                            value-key="id"
                            :placeholder="$t('Select tags')"
                            v-model="settingsDialog.form.memberTags"
                            @change="$refs.memberTagSelect.blur()"
                        )
                            el-option(
                                v-for="tag in pageOptions.extensions.restrictedArea.memberTag.items"
                                :key="tag.id"
                                :label="tag.name"
                                :value="tag"
                            )
        template(slot="footer")
            el-button(
                size="mini"
                icon="el-icon-fa-times fas"
                @click="closeSettingsModal"
            ) {{ $t('Dismiss') }}
            el-button(
                :disabled="settingsDialog.loading"
                size="mini"
                type="primary"
                icon="el-icon-fa-check fas"
                @click="updateSettings"
            ) {{ $t('Save Settings') }}

    el-dialog.duplicate-menu-item-dialog(
        :title="duplicateDialogTitle"
        :visible.sync="duplicateDialog.visibility"
        :close-on-click-modal="false"
        :append-to-body="true"
        top="10vh"
        width="460px"
    )
        .body(v-loading="duplicateDialog.loading")
            p {{ $t('Do you really want to duplicate the menu item?') }}
            el-checkbox(
                v-if="duplicateDialog.item && hasChildren(duplicateDialog.item)"
                v-model="duplicateDialog.includeChildren"
            ) {{ $t('Include sub items') }}
        template(slot="footer")
            .modal-footer
                .right
                    el-button(
                        size="mini"
                        icon="el-icon-fa-times fas"
                        :disabled="duplicateDialog.loading"
                        @click="closeDuplicateDialog"
                    ) {{ $t('Cancel') }}
                    el-button(
                        size="mini"
                        type="primary"
                        icon="el-icon-fa-clone fas"
                        :disabled="duplicateDialog.loading"
                        @click="duplicateItem"
                    ) {{ $t('Duplicate') }}

    el-dialog.delete-menu-item-dialog(
        :title="deleteDialogTitle"
        :visible.sync="deleteDialog.visibility"
        :close-on-click-modal="false"
        :append-to-body="true"
        top="10vh"
        width="460px"
    )
        .body(v-loading="deleteDialog.loading")
            p {{ $t('Do you really want to delete the menu item?') }}
        template(slot="footer")
            .modal-footer
                .left
                    el-checkbox(v-model="deleteDialog.remember") {{ $t("Don't keep asking") }}
                .right
                    el-button(
                        size="mini"
                        icon="el-icon-fa-times fas"
                        :disabled="deleteDialog.loading"
                        @click="closeDeleteDialog"
                    ) {{ $t('Cancel') }}
                    el-button(
                        size="mini"
                        type="danger"
                        icon="el-icon-fa-trash-alt fas"
                        :disabled="deleteDialog.loading"
                        @click="() => deleteItem(deleteDialog.item)"
                    ) {{ $t('Delete') }}
</template>

<i18n>
{
    "de": {
        "Start page": "Startseite",
        "Replaces the current start page.": "Ersetzt die bisherige Startseite.",
        "Without a start page, visitors get an error page.": "Ohne Startseite bekommen Besucher eine Fehlerseite.",
        "Menu items": "Menüpunkte",
        "Menu Not Found": "Menü konnte nicht gefunden werden.",
        "Expand all": "aufklappen",
        "Collapse all": "zuklappen",
        "Something went wrong!": "Etwas ist schiefgelaufen!",
        "Menu Item could not be fetched.": "Menüpunkt konnte nicht abgerufen werden.",
        "This menu has no items yet": "Dieses Menü hat noch keine Menüeinträge",
        "Add new page": "Neue Seite hinzufügen",
        "Add Menu Item": "Menüeintrag hinzufügen",
        "Create Menu Item": "Menüeintrag erstellen",
        "Position": "Position",
        "under": "unter",
        "into": "in",
        "URL Key": "URL Schlüssel",
        "URL": "URL",
        "Orphans": "Waisen",
        "Preview": "Vorschau",
        "Preview could not be rendered": "Vorschau konnte nicht generiert werden",
        "Settings": "Einstellungen",
        "Save Settings": "Einstellungen speichern",
        "Menu dependencies could not be fetched.": "Menüabhängigkeiten konnten nicht abgerufen werden.",
        "Menu Item dependencies could not be fetched.": "Menüpunktabhängigkeiten konnten nicht abgerufen werden.",
        "Menu Item hidden successfully!": "Menüpunkt erfolgreich ausgeblendet!",
        "Menu Item could not be hidden.": "Menüpunkt konnte nicht ausgeblendet werden.",
        "Menu Item made visible successfully!": "Menüpunkt erfolgreich eingeblendet!",
        "Menu Item could not be made visible.": "Menüpunkt konnte nicht eingeblendet werden.",
        "Menu Item could not be deleted.": "Menüpunkt konnte nicht gelöscht werden.",
        "Copy content from": "Inhalte übernehmen von",
        "Menu Item content could not be cloned.": "Menüpunkt-Inhalte konnten nicht übernommen werden.",
        "Optional": "Optional",
        "No menu item selected!": "Kein Menüpunkt ausgewählt!",
        "Menu could not be saved.": "Menü konnte nicht gespeichert werden.",
        "Menu saved successfully!": "Menü erfolgreich gespeichert!",
        "Delete Menu Item": "Menüpunkt löschen",
        "Delete menu item \"{title}\"": "Menüpunkt „{title}“ löschen",
        "Menu Item has been deleted successfully": "Menüpunkt wurde erfolgreich gelöscht",
        "Menu Item could not be deleted!": "Menüpunkt konnte nicht gelöscht werden!",
        "Do you really want to delete the menu item?": "Soll der Menüpunkt wirklich gelöscht werden?",
        "Show": "Einblenden",
        "Hide": "Ausblenden",
        "Delete": "Löschen",
        "Duplicate Menu Item": "Menüpunkt duplizieren",
        "Duplicate menu item \"{title}\"": "Menüpunkt „{title}“ duplizieren",
        "Do you really want to duplicate the menu item?": "Soll der Menüpunkt wirklich dupliziert werden?",
        "Include sub items": "Unterpunkte einschließen",
        "Duplicate": "Duplizieren",
        "(Copy)": "(Kopie)",
        "Menu Item could not be duplicated.": "Menüpunkt konnte nicht dupliziert werden.",
        "Everybody": "Jedem",
        "Members": "Mitgliedern",
        "Guests": "Gästen",
        "Any": "Alle",
        "Only members with the following tags can access this menu": "Nur Mitglieder mit den folgenden Tags haben Zugang zu diesem Menü",
        "Select tags": "Tags auswählen",
        "Accessible by": "Zugänglich von",
        "Drag to resize, double-click to reset": "Zum Vergrößern/Verkleinern ziehen, Doppelklick zum Zurücksetzen"
    }
}
</i18n>

<script>
import { isApplePlatform } from '@/helpers/shortcuts';
import _ from 'lodash';
import Vue from 'vue';

import uniqid from 'uniqid';
import { adminClient as apolloClient } from '@/store/apollo';
import pinia from '@/pinia';
import { useSetupStore, useMenuStore, usePageStore } from '@/stores';

import NestedSet from '@/nested-set-lib';
import MenuApi from '@/store/api/cms/menu';
// import MemberTagApi from '@/extensions/restrictedArea/store/api/memberTag';

import router from '@/router';
import store from '@/store';

import { checkRestrictions } from '@/helpers';
import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import PreviewDrawer from '@/components/PreviewDrawer';

import Treeselect from '@riophae/vue-treeselect';
import discardGuard from '@/mixins/discardGuard';

const TREE_WIDTH = 350;
const TREE_WIDTH_MIN = 240;
const TREE_WIDTH_MAX = 800;
const TREE_WIDTH_COOKIE_KEY = 'menu-tree-width';

const clampTreeWidth = (width) => Math.min(TREE_WIDTH_MAX, Math.max(TREE_WIDTH_MIN, Math.round(width)));

const getCookie = (name) => {
    if (typeof document === 'undefined') return '';
    const escapedName = String(name).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
};

const setCookie = (name, value, days = 365) => {
    if (typeof document === 'undefined') return;
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

const rememberedTreeWidth = () => {
    const stored = parseFloat(getCookie(TREE_WIDTH_COOKIE_KEY));
    return isNaN(stored) ? TREE_WIDTH : clampTreeWidth(stored);
};

export default {
    name: 'Menu',
    mixins: [discardGuard],
    data() {
        return {
            uniqid: uniqid(), // reload tree

            // Drag-to-resize for the menu tree column (persisted to a cookie).
            treeWidth: rememberedTreeWidth(),
            treeResize: null,
            // Position of the (position:fixed) grip, computed in px relative to its
            // actual containing block so it sits on the gutter at the vertical centre
            // of the viewport — robust even if a transformed ancestor traps `fixed`.
            treeGripLeft: 0,
            treeGripTop: 0,

            staging: process.env.NODE_ENV === 'staging',

            error: false,
            notFound: false,
            loading: false,
            saving: false,
            savingAndClose: false,

            expandedKeys: [],
            treeProps: {
                label: 'title',
                disabled: 'deleted'
            },
            // usedPaths: [],

            newItemDialog: {
                visibility: false,
                loading: false,
                formSnapshot: undefined,
                form: {
                    item: {
                        title: '',
                        path: '',
                        hidden: false,
                        // A store serves its domain root through the item flagged as
                        // homepage; there is no menu item whose path is "/".
                        homepage: false,
                        component: null,
                        restriction: null,
                        page: null
                    },
                    position: 'after',
                    target: null,
                    sourceMenuItemId: null,
                },
            },

            settingsDialog: {
                visibility: false,
                loading: false,
                formSnapshot: undefined,
                form: {
                    name: '',
                    restriction: null,
                    memberTags: []
                },
            },

            deleteDialog: {
                visibility: false,
                loading: false,
                remember: false,
                item: undefined
            },

            duplicateDialog: {
                visibility: false,
                loading: false,
                includeChildren: false,
                item: undefined
            },

            restrictions: [
                {
                    key: 'everybody',
                    value: null,
                    name: this.$t('Everybody')
                },
                {
                    key: 'members',
                    value: 'members',
                    name: this.$t('Members')
                },
                {
                    key: 'guests',
                    value: 'guests',
                    name: this.$t('Guests')
                }
            ],

            previewDrawer: {
                visibility: false,
                src: undefined,
                loading: false
            },

            contentWidth: undefined,
        };
    },
    components: {
        Tabs,
        Error,
        Treeselect,
        PreviewDrawer
    },
    watch: {
        'ui.expandAll': function (expand) {
            if (!expand) {
                this.expandedKeys = [];
                this.expandAncestorItems(this.$route.params.id);
            }
            this.uniqid = uniqid(); // reload tree
        },
        'newItemDialog.form.item.title': function (value) {
            if (!value) {
                // || _.get(this.newItemDialog.form, 'type.key') === 'Redirect'
                this.newItemDialog.form.item.path = '';
                return;
            }

            const requestedPath = _.kebabCase(value);
            let path = requestedPath;

            var i = 0;
            while (this.usedPaths.indexOf(`/${path}`) >= 0) {
                ++i;
                path = `${requestedPath}-${i}`;
            }

            this.newItemDialog.form.item.path = `/${path}`;
        },
        'form.menuItems': function (fresh, old) {
            if ((!old || old.length === 0) || (fresh && fresh.length)) {
                this.$nextTick(this.calculateContentWidth)
                this.$nextTick(this.observeTreeResize)
                this.$nextTick(this.updateTreeGripPosition)
                // el-tree renders its rows asynchronously; recompute once the panel
                // height has settled so the grip ends up centred, not on a stale value.
                setTimeout(this.updateTreeGripPosition, 300)
                // this.$nextTick(this.calculateTreeWidth)
            }
        },
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.setInitializedFlag(false);
                this.initialize();
            }
        }
    },
    computed: {
        // Across the whole store, not just this menu: the flag lives on one item and
        // the storefront resolves "/" through it.
        storeHasHomepage() {
            const outside = _.get(this.menuStore, 'validation.homepageExistsOutsideCurrentMenu', false);
            const inCurrentMenu = (_.get(this.form, 'menuItems') || []).some(item => item.homepage);

            return outside || inCurrentMenu;
        },
        id() {
            return _.get(this.form, 'id', false);
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose;
        },
        key() {
            return this.$route.params.key;
        },
        activeTab() {
            // let tab = this.$route.fullPath
            // if (this.$route.name !== 'menu-form') {
            //     const route = this.$route.matched.find(route => route.name === 'menu-form')
            //     if (route) tab = route.path.replace(':key?', this.key)
            // }
            // return tab

            return `/menu/${this.key}`;
        },
        tabs() {
            let menus = _.get(this.activeCms, 'config.template.menus') || [];
            menus = _.orderBy(menus, 'position');

            let tabs = [];
            menus.forEach(menu => {
                const showMenu = this.checkConditions(menu)
                if (showMenu) {
                    tabs.push({
                        name: menu.name,
                        key: menu.key,
                        path: `/menu/${menu.key}`,
                        icon: {
                            name: 'bars',
                            group: 'fas'
                        }
                    });
                }
            });

            return tabs;
        },
        tree() {
            let items = _.get(this.form, 'menuItems', []);
            items = _.cloneDeep(items);

            let tree = NestedSet.createTree(items);
            // if (tree.length) tree = [{ name: 'foo' }, ...tree]
            return tree;
        },
        currentItem() {
            const menuItems = _.get(this.form, 'menuItems', []);
            // const currentID = _.get(router, 'history.current.params.id')
            const currentID = _.get(this.$route, 'params.id');

            if (menuItems.length && currentID) {
                const item = menuItems.find(item => item.id.toString() === currentID.toString());
                if (item) return item;
                else {
                    // this.$notify.error({
                    //     title: this.$t('An error occurred!'),
                    //     message: this.$t('Menu Item could not be found.'),
                    //     iconClass: 'fas el-icon-fa-xmark',
                    //     position: 'bottom-left',
                    //     customClass: 'dark',
                    //     duration: 8000,
                    // })

                    const id = menuItems[0].id;
                    const route = router.history.current.matched.find(
                        route => route.components.default.name === 'menu-form'
                    );

                    if (route && id) {
                        router.replace(`${route.path}`);
                    }

                    return null;
                }
            } else {
                return null;
            }
        },
        newItemRules() {
            let rules = {
                item: {
                    title: 'required',
                    component: {
                        view: 'required'
                    }
                }
            };

            const type = _.get(this.newItemDialog.form, 'item.component.view');
            if (type !== 'Redirect') {
                rules.item.path = `required|absolute_path|excluded:${this.usedPaths.join(',')}`;
            } else {
                rules.item.redirect = 'required|url';
            }

            // if (this.modalTab === 'new') {
            //     const exclude = this.usedKeys.join(',')

            //     rules.name = 'required|min:3'
            //     rules.view = `required|excluded:${exclude}`
            //     rules.propType = 'required'

            //     if (this.newItemDialog.form.propType && this.newItemDialog.form.propType.key === 'date') {
            //         rules.datetype = 'required'
            //     }
            // }

            return rules;
        },
        settingsRules() {
            let rules = {
                name: 'required|min:3',
            };
            return rules;
        },
        usedPaths() {
            let usedPaths = _.cloneDeep(this.validation.usedPaths);
            _.get(this.form, 'menuItems', []).forEach(item => usedPaths.push(item.path));

            return usedPaths;
        },
        deleteDialogTitle() {
            const title = _.get(this.deleteDialog, 'item.title');
            return title ? this.$t('Delete menu item "{title}"', { title }) : this.$t('Delete Menu Item');
        },
        duplicateDialogTitle() {
            const title = _.get(this.duplicateDialog, 'item.title');
            return title ? this.$t('Duplicate menu item "{title}"', { title }) : this.$t('Duplicate Menu Item');
        },
        collapsables() {
            // get all nodes with children
            // except for the ancestors of the current item

            const items = _.get(this.form, 'menuItems') || [];
            let collapsables = items.filter(el => el._rgt - el._lft > 1);

            if (this.$route.params.id) {
                const item = items.find(el => el.id.toString() === this.$route.params.id.toString());
                if (item) {
                    const ancestors = NestedSet.getAncestors(items, item).map(el => el.id);
                    if (ancestors.length) {
                        collapsables = collapsables.filter(el => !ancestors.includes(el.id));
                    }
                }
            }

            return collapsables.map(el => el.id);
        },
        settingValues() {
            return useSetupStore().settingValues;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        // Member restriction is functionality, not a sold row - a shop carries it
        // without the restricted-area extension ever being attached.
        effectiveExtensions() {
            return useSetupStore().effectiveExtensions;
        },
        menuStore() {
            return useMenuStore();
        },
        form() {
            return this.menuStore.form;
        },
        rules() {
            return this.menuStore.rules;
        },
        validation() {
            return this.menuStore.validation;
        },
        menuOptions() {
            return this.menuStore.options;
        },
        ui() {
            return this.menuStore.ui;
        },
        initialized() {
            return this.menuStore.formInitialized;
        },
        pageStore() {
            return usePageStore();
        },
        pageOptions() {
            return this.pageStore.options;
        },
        allMenuItemsForCloning() {
            var templateMenus = _.get(this.activeCms, 'config.template.menus') || [];
            templateMenus = _.orderBy(templateMenus, 'position');

            var menuOptions = _.get(this.pageOptions, 'menu.items') || [];
            var tree = [];

            templateMenus.forEach(function (templateMenu) {
                var menuOption = _.find(menuOptions, { key: templateMenu.key });
                var items = _.cloneDeep(_.get(menuOption, 'menuItems') || []);
                if (items.length) {
                    var optgroup = {
                        id: 'optgroup-clone-' + menuOption.id,
                        title: menuOption.name,
                        isDisabled: true,
                        optgroup: true,
                    };
                    tree.push(optgroup);
                    tree = tree.concat(NestedSet.createTree(items));
                }
            });

            return tree;
        },
        canShowPreview() {
            if (!this.currentItem) return false;

            const pageView = _.get(this.currentItem, 'page.view');
            const hiddenViews = ['Folder', 'Directory', 'Logout'];

            if (hiddenViews.includes(pageView)) return false;

            // For redirects, check if we can resolve to a final destination
            if (pageView === 'Redirect') {
                const finalItem = this.resolveRedirectChain(this.currentItem);
                return finalItem && finalItem.path;
            }

            return !!this.currentItem.path;
        },
        previewShortcut() {
            return isApplePlatform() ? '⌘P' : 'Ctrl+P';
        }
    },
    methods: {
        resolveRedirectChain(menuItem, visited = new Set()) {
            if (!menuItem) return null;

            // Prevent infinite loops
            if (visited.has(menuItem.id)) return null;
            visited.add(menuItem.id);

            const pageView = _.get(menuItem, 'page.view');

            // If not a redirect, return the current item
            if (pageView !== 'Redirect') {
                return menuItem;
            }

            const redirectType = _.get(menuItem, 'page.redirect.type');

            // For external redirects, we can't preview
            if (redirectType === 'external') {
                return null;
            }

            // For internal redirects, find the target menu item
            if (redirectType === 'internal') {
                const targetMenuItemId = _.get(menuItem, 'page.redirect.menuItem.id');
                if (!targetMenuItemId) return null;

                const menuItems = _.get(this.form, 'menuItems', []);
                const targetItem = menuItems.find(item => item.id === targetMenuItemId);

                // Recursively resolve if target is also a redirect
                return this.resolveRedirectChain(targetItem, visited);
            }

            // For other redirect types (mailto, tel, etc.), we can't preview
            return null;
        },
        showPreviewModal() {
            this.previewDrawer.visibility = true;
            this.previewDrawer.loading = true;

            this.$nextTick(() => {
                const baseUrl = _.get(this.activeCms, 'domains.0.base_url');

                let protocol = 'http:';
                if (process.env.NODE_ENV === 'production') protocol = window.location.protocol;

                // Resolve redirect chain if needed
                const pageView = _.get(this.currentItem, 'page.view');
                let path;

                if (pageView === 'Redirect') {
                    const finalItem = this.resolveRedirectChain(this.currentItem);
                    path = _.get(finalItem, 'path', '/');
                } else {
                    path = _.get(this, 'currentItem.path', '/');
                }

                let iframeSrc = `${protocol}//${baseUrl}${path}`;

                const urlObj = new URL(iframeSrc);
                urlObj.searchParams.set('no-cache', 'true');
                this.previewDrawer.src = urlObj.toString();

                this.previewDrawer.loading = false;
            });
        },
        resetPreviewModal() {
            this.previewDrawer = {
                visibility: false,
                src: undefined,
                loading: false
            };
        },
        handleKeyDown(event) {
            // Cmd+P (Mac) or Ctrl+P (Windows/Linux)
            if ((event.metaKey || event.ctrlKey) && event.key === 'p') {
                event.preventDefault();
                if (this.canShowPreview) {
                    this.showPreviewModal();
                }
            }
        },
        forceCollapseAll() {
            if (this.ui.expandAll !== false) {
                this.collapseAll();
            } else {
                this.expandedKeys = [];
                this.expandAncestorItems(this.$route.params.id);
                this.uniqid = uniqid(); // reload tree
            }
        },
        forceExpandAll() {
            if (this.ui.expandAll !== true) {
                this.expandAll();
            } else {
                this.expandedKeys = [];
                this.expandAncestorItems(this.$route.params.id);
                this.uniqid = uniqid(); // reload tree
            }
        },
        initialize(key = null) {
            if (this.initialized !== true) {
                this.setInitializedFlag(true);

                // const route = router.history.current.matched.find(route => route.components.default.name === 'Menu')
                // const key = _.get(route, 'meta.key')

                if (key === null) key = this.key;

                this.error = false;
                this.notFound = false;

                this.loading = true;

                this.updateItemTypeOptionsLoading(true);
                this.updateSectionOptionsLoading(true);

                if (key) {
                    const menus = _.get(this.activeCms, 'config.template.menus', []);
                    const fetchDependencies = () => {
                        const allowedMenuItems = _.get(this.activeCms, 'config.template.pages', []);
                        this.insertItemTypeOptions(allowedMenuItems);
                        this.updateItemTypeOptionsLoading(false);

                        const allowedSections = _.get(this.activeCms, 'config.template.sections', []);
                        this.insertSectionOptions(allowedSections);
                        this.updateSectionOptionsLoading(false);

                        let dependencies = [
                            this.fetchMenuOptions(this.activeCms.id),
                            this.fetchTagOptions(this.activeCms.id),
                            this.fetchFileTagOptions(this.activeCms.id),
                            this.fetchMemberTagOptions(this.activeCms.id),
                            this.fetchMenuItemPaths({ id: this.activeCms.id, key })
                        ];

                        // extensions
                        // fetch only if the corresponding extension is availible / active

                        if (this.enabledExtensions.includes('event-manager') && checkRestrictions('ex:evnt')) {
                            dependencies.push(this.fetchEventCategoryOptions(this.activeCms.id));
                        }
                        if (this.enabledExtensions.includes('shop') && checkRestrictions('ex:shop')) {
                            dependencies.push(this.fetchShopCategoryOptions(this.activeCms.shop.id));
                            dependencies.push(this.fetchPropertyOptions(this.activeCms.shop.id));
                            dependencies.push(this.fetchShopTagOptions(this.activeCms.shop.id));
                        }
                        if (this.enabledExtensions.includes('marketing') && checkRestrictions('ex:marketing')) {
                            dependencies.push(this.fetchMarketingCampaignOptions(this.activeCms.id));
                        }
                        if (this.enabledExtensions.includes('newsletter') && checkRestrictions('ex:newsletter')) {
                            dependencies.push(this.fetchSubscriptionTopicOptions(this.activeCms.id));
                        }

                        return Promise.allSettled(dependencies);
                    };

                    // fetch options for dropdowns
                    fetchDependencies().then(function (results) {
                        var rejected = results.filter(function (result) {
                            return result.status === 'rejected';
                        });

                        if (rejected.length) {
                            rejected.forEach(function (result) {
                                // eslint-disable-next-line no-console
                                console.warn('Dependency fetch failed:', result.reason);
                            });
                        }
                    }.bind(this));

                    this.fetchMenu({ key, cms: this.activeCms.id })
                        // TODO: Kein vorhandenens Menü anders abfangen, Exception Handling per apollo/index.js
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                // add = false;
                                this.error = true;

                                /* eslint no-console: ["error", { allow: ["error"] }] */
                                console.error(err);
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                default:
                                    // add new menu to state

                                    const config = _.get(this.activeCms, 'config.template.menus', []).find(
                                        menu => menu.key === key
                                    );
                                    if (!config) this.notFound = true;
                                    else {
                                        const name = config.name || key;
                                        this.menuStore.insertMenu({ key, name, menuItems: [] });
                                    }
                                    break;
                            }
                        })
                        .then(() => {
                            // check if there are more items than 50
                            // and there are collapsables
                            // set ui.expandAll = false

                            const items = _.get(this.form, 'menuItems') || [];
                            if (this.ui.expandAll === false || items.length > 50 && this.collapsables.length) {
                                this.forceCollapseAll();
                            }
                            this.expandAncestorItems(this.$route.params.id);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.error = true;
                    this.loading = false;
                }
            } else {
                this.expandAncestorItems(this.$route.params.id);
            }
        },
        expandAncestorItems(id) {
            if (id) {
                // this.expandedKeys.push(id)

                const items = _.get(this.form, 'menuItems') || [];
                const item = items.find(el => el.id.toString() === id.toString());

                if (item) {
                    const ancestors = NestedSet.getAncestors(items, item);
                    ancestors.forEach(el => {
                        if (!this.expandedKeys.includes(el.id)) this.expandedKeys.push(el.id);
                    });

                    // if (ancestors && ancestors.length) {
                    //     this.expandedKeys.push(id)
                    // }
                }
            }
        },
        // submit() {
        //     this.$refs.form.validate((valid, errors) => {
        //         if (valid) {
        //             const itemID = this.$route.params.id;

        //             let currentItem = null;
        //             if (itemID) {
        //                 currentItem = _.get(this.form, 'menuItems', []).find(
        //                     item => item.id.toString() === itemID.toString()
        //                 );
        //             }

        //             this.saving = true;

        //             let save = this.create;
        //             if (this.id) save = this.update;

        //             let menu = _.cloneDeep(this.form);
        //             menu.cms = { id: this.activeCms.id };
        //             save(menu)
        //                 .then(async data => {
        //                     let menu = _.cloneDeep(data);
        //                     if (currentItem && currentItem.path) {
        //                         // const route = router.history.current.matched.find(route => route.components.default.name === 'Menu')
        //                         const menuItems = _.get(menu, 'menuItems', []);

        //                         let index = null;
        //                         if (_.startsWith(itemID, 'new:')) {
        //                             index = _.findIndex(menuItems, item => item.path === currentItem.path);
        //                         } else {
        //                             index = _.findIndex(menuItems, item => item.id.toString() === itemID.toString());
        //                         }

        //                         let item = null;
        //                         if (index >= 0) item = menuItems[index];

        //                         if (item && item.id) {
        //                             // in production gibt es an dieser Stelle einen Fehler ohne den Timeout.
        //                             // Next Tick geth auch nicht
        //                             // TODO: bessere Lösung finden
        //                             const delay = ms => new Promise(resolve => setTimeout(resolve, ms))
        //                             await delay(0)

        //                             await this.fetchMenuItem(item.id)
        //                                 .then(menuItem => {
        //                                     if (menuItem) menu.menuItems[index] = menuItem;
        //                                 })
        //                                 .catch(err => {
        //                                     this.$notify.error({
        //                                         title: this.$t('An error occurred!'),
        //                                         message: this.$t('Menu Item could not be fetched.'),
        //                                         iconClass: 'fas el-icon-fa-xmark',
        //                                         position: 'bottom-left',
        //                                         customClass: 'dark',
        //                                         duration: 8000
        //                                     });
        //                                 })
        //                                 .finally(() => {
        //                                     this.saving = false;
        //                                     store.commit('menu/insertMenu', menu);

        //                                     this.$nextTick(() => store.commit('menu/resetRules'));

        //                                     if (itemID.startsWith('new:')) {
        //                                         this.$nextTick(() => {
        //                                             // router.replace(`${route.path}/${item.id}`)
        //                                             const params = {
        //                                                 key: this.key,
        //                                                 id: item.id
        //                                             };
        //                                             router.replace({ name: 'menu-item', params });
        //                                         });
        //                                     }
        //                                 });

        //                         } else {
        //                             this.saving = false;

        //                             store.commit('menu/insertMenu', menu);
        //                             // this.$nextTick(() => {
        //                             //     router.replace(`${route.path}`)
        //                             // })
        //                         }
        //                     } else {
        //                         this.saving = false;
        //                         store.commit('menu/insertMenu', menu);
        //                     }

        //                     this.$notify.success({
        //                         title: this.$t('Menu saved successfully!'),
        //                         iconClass: 'fas el-icon-fa-check',
        //                         position: 'bottom-left',
        //                         customClass: 'dark',
        //                         duration: 8000
        //                     });
        //                 })
        //                 .catch(err => {
        //                     /* eslint no-console: ["error", { allow: ["error"] }] */
        //                     console.error(err);

        //                     this.saving = false;

        //                     this.$notify.error({
        //                         title: this.$t('An error occurred!'),
        //                         message: this.$t('Menu could not be saved.'),
        //                         iconClass: 'fas el-icon-fa-xmark',
        //                         position: 'bottom-left',
        //                         customClass: 'dark',
        //                         duration: 8000
        //                     });
        //                 });
        //         } else {
        //             // TODO: show errors
        //             // go to the next error if there is none on the current view
        //         }
        //     });
        // },
        toggleExpand(node) {
            if (node.expanded && this.expandedKeys.includes(node.data.id)) {
                const index = this.expandedKeys.findIndex(el => el === node.data.id);
                if (index >= 0) this.$delete(this.expandedKeys, index);

                // NOTE
                // workaround: delete also all children
                // don't put them back right after
                const items = _.get(this.form, 'menuItems', []);
                const children = NestedSet.getChildren(items, node.data).filter(el => el._rgt - el._lft > 1);
                children.forEach(child => {
                    const index = this.expandedKeys.findIndex(el => el === child.id);
                    if (index >= 0) this.$delete(this.expandedKeys, index);
                });
            } else if (!node.expanded) {
                const index = this.expandedKeys.findIndex(el => el === node.data.id);
                if (index < 0) this.expandedKeys.push(node.data.id);
            }

            this.$set(node, 'expanded', !node.expanded);
            this.expandAncestorItems(this.$route.params.id);
            // this.uniqid = uniqid()
        },
        openNewItemModal() {
            this.newItemDialog.loading = true;
            this.newItemDialog.visibility = true;

            // A store with no start page cannot serve its domain root at all, so the
            // first page it creates offers to be it. Once one exists this stays off,
            // because turning it on MOVES the start page.
            this.newItemDialog.form.item.homepage = !this.storeHasHomepage;

            setTimeout(() => {
                // this.$refs.newItemDialog.form.esetFields()
                this.$refs.newItemForm.clearValidate()
            })

            const fetchOptions = () =>
                Promise.all([
                    // MenuApi.fetchItemPaths(this.activeCms.id, this.form.key)
                    //     .then(items => items.forEach(item => this.usedPaths.push(item.path))),
                ]);

            const defaultType = _.find(this.menuOptions.itemType.items, 'default');
            this.newItemDialog.form.item.component = defaultType;
            // this.newItemDialog.form.item.view = _.get(defaultType, 'view')

            const defaultTarget = this.currentItem || _.head(this.tree);
            this.newItemDialog.form.target = _.get(defaultTarget, 'id');
            this.newItemDialog.formSnapshot = this.snapshotOf(this.newItemDialog.form);

            fetchOptions()
                .then(() => {
                    // TODO: rules

                    // setTimeout(() => (this.newItemDialog.loading = false), 0);
                    this.newItemDialog.loading = false;
                })
                .catch(err => {
                    this.newItemDialog.visibility = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Menu Item dependencies could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        // setViewInForm(item) {
        //     this.newItemDialog.form.item.view = _.get(item, 'view')
        // },
        async addMenuItem() {
            // API request: create item

            this.newItemDialog.loading = true

            this.$refs.newItemForm.validate(async valid => {
                if (valid) {
                    const id = uniqid('new:');
                    this.newItemDialog.form.item.id = id;
                    this.newItemDialog.form.item.page = {
                        id,
                        view: this.newItemDialog.form.item.component.view
                    };

                    const configExtension = _.get(this.newItemDialog.form.item, 'component.extension');
                    if (configExtension && configExtension.key) {
                        const extension = this.activeCms.extensions
                            .find(extension => extension.key === configExtension.key) || null;
                        this.newItemDialog.form.item.page.extension = extension;
                    }

                    const view = _.get(this.newItemDialog.form, 'item.component.view');
                    switch (view) {
                        case 'LoginPage':
                            this.newItemDialog.form.item.restriction = 'guests';
                            break;
                        case 'Logout':
                            this.newItemDialog.form.item.restriction = 'members';
                            break;
                        default:
                            this.newItemDialog.form.item.restriction = null;
                            break;
                    }
                    // this.addItem(this.newItemDialog.form);

                    // const items = _.get(this.form, 'menuItems') || [];
                    const { target, item, position, sourceMenuItemId } = this.newItemDialog.form

                    if (sourceMenuItemId) {
                        // Clone path: one request that creates the menu item AND clones content
                        try {
                            var menu = await MenuApi.cloneMenuItem({
                                sourceMenuItemId: parseInt(sourceMenuItemId),
                                menuId: parseInt(this.id),
                                menuItem: item,
                                targetMenuItemId: target ? parseInt(target) : null,
                                position: position,
                            });

                            apolloClient.cache.reset();
                            this.menuStore.insertMenu(menu);
                            this.fetchMenuOptions(this.activeCms.id);
                            this.fetchMenuItemPaths({ id: this.activeCms.id, key: this.key });

                            var clonedItems = _.cloneDeep(menu.menuItems || []).sort(function (a, b) { return a.id - b.id; });
                            var newItem = clonedItems[clonedItems.length - 1];
                            if (newItem) this.changeCurrentItem(newItem);
                            this.closeNewItemModal();
                        } catch (error) {
                            this.newItemDialog.loading = false;
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Menu Item content could not be cloned.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                            });
                        }
                    } else {
                        // Normal path: create menu item via saveTree
                        // const draggingNode = { data: item }
                        // const dropNode = { data: items.find(el => el.id === target) }
                        // const newItem = await this.moveMenuItem(draggingNode, dropNode, position)

                        const tree = _.cloneDeep(this.tree)

                        // Function to add an item into the tree
                        const addItemToTree = (tree, newItem, targetId, position) => {
                            // Helper function to find the target node and insert the new item
                            const traverseAndInsert = (nodes) => {
                                for (let i = 0; i < nodes.length; i++) {
                                    if (nodes[i].id === targetId) {
                                        if (position === 'before') {
                                            nodes.splice(i, 0, newItem);
                                        } else if (position === 'after') {
                                            nodes.splice(i + 1, 0, newItem);
                                        } else if (position === 'into') {
                                            if (!nodes[i].children) {
                                                nodes[i].children = [];
                                            }
                                            nodes[i].children.push(newItem);
                                        }
                                        return true;
                                    }
                                    if (nodes[i].children && traverseAndInsert(nodes[i].children)) {
                                        return true;
                                    }
                                }
                                return false;
                            };

                            if (tree.length === 0) tree.push(newItem);
                            else traverseAndInsert(tree);
                        };

                        addItemToTree(tree, item, target, position);

                        // console.log('>>>', tree)
                        // this.newItemDialog.loading = false

                        const menu = await this.saveTree(tree);

                        if (!menu) {
                            this.newItemDialog.loading = false;
                            return;
                        }

                        const items = _.cloneDeep(menu.menuItems || []).sort((a, b) => a.id - b.id)
                        const newItem = items[menu.menuItems.length - 1]

                        apolloClient.cache.reset();

                        // refetch menu options
                        this.fetchMenuOptions(this.activeCms.id),
                        this.fetchMenuItemPaths({ id: this.activeCms.id, key: this.key })

                        if (newItem) this.changeCurrentItem(newItem);
                        this.closeNewItemModal();
                    }
                }
            });
        },
        isDraggable(node) {
            return node.data.id !== '__orphans';
        },
        isDeletable(data) {
            return data.id !== '__orphans';
        },
        isOrphan(data) {
            const items = _.get(this.form, 'menuItems') || [];
            const ancestors = NestedSet.getAncestors(items, data).map(item => item.id);

            return data.id === '__orphans' || ancestors.includes('__orphans');
        },
        async moveMenuItem(draggingNode, dropNode, position) {
            // const backup = _.cloneDeep(this.tree)
            //
            // const move = (tree, target, item) => {
            //     const i = tree.findIndex(el => el.id === item.id);
            //     if (i >= 0) tree.splice(i, 1);
            //
            //     const t = tree.findIndex(el => el.id === target.id);
            //     if (t >= 0) {
            //         switch (position) {
            //             case 'before':
            //                 tree.splice(t, 0, item);
            //                 break;
            //             case 'after':
            //                 tree.splice(t + 1, 0, item);
            //                 break;
            //             case 'into':
            //                 if (!tree[t].children) tree[t].children = []
            //                 tree[t].children.push(item);
            //                 break;
            //             case 'inner':
            //                 // NOTE: creates duplicates
            //                 // if (!tree[t].children) tree[t].children = []
            //                 // tree[t].children.push(item);
            //                 break;
            //         }
            //     } else if (tree.length > 0) {
            //         tree.forEach(el => {
            //             if (el.children && el.children.length) {
            //                 el.children = move(el.children, target, item);
            //             }
            //         });
            //     } else {
            //         tree = []
            //         tree.push(item)
            //     }
            //
            //     const o = tree.findIndex(el => el.id === '__orphans');
            //     if (o >= 0) {
            //         const orphans = tree[o].children || [];
            //         if (orphans.length === 0) tree.splice(o, 1);
            //     }
            //
            //     return tree
            // };
            //
            // const tree = move(this.tree, dropNode.data, draggingNode.data)

            const tree = _.cloneDeep(this.tree)
            const menu = await this.saveTree(tree);

            // if (menu.menuItems.length) {
            //     if (!draggingNode.data.id || _.startsWith(draggingNode.data.id, 'new:')) {
            //         const items = _.cloneDeep(menu.menuItems).sort((a, b) => a.id - b.id)
            //         return items[menu.menuItems.length - 1]
            //     } else {
            //         return menu.menuItems.find(el => el.id === draggingNode.data.id)
            //     }
            // }

            return menu
        },
        async saveTree(tree) {
            let items = _.get(this.form, 'menuItems', []);
            const backup = _.cloneDeep(items)

            items = NestedSet.flattenTree(tree)
            this.menuStore.setState({ path: 'form.menuItems', value: items })

            // this.moveItem({ item: draggingNode.data, target: dropNode.data, position });

            // save menu / item positions
            // payload for the saveMenu mutation
            const payload = {
                id: this.id || uniqid('new:'),
                menuItems: items
            }

            if (!this.id) {
                payload.cms = { id: this.activeCms.id }
                payload.key = this.key
                payload.name = this.form.name
            }

            return await this.menuStore.save(payload)
                .then(menu => {
                    this.menuStore.insertMenu(menu)
                    return menu
                })
                .catch(error => {
                    this.menuStore.setState({ path: 'form.menuItems', value: backup })

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Menu could not be saved.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(error)
                })
        },
        hasDisabledAncestor(data) {
            const items = _.get(this.form, 'menuItems') || [];
            const deletedAncestors = NestedSet.getAncestors(items, data).filter(item => item.disabled);
            return deletedAncestors.length;
        },
        // hasDeletedAncestor(data) {
        //     const items = _.get(this.form, 'menuItems') || [];
        //     const deletedAncestors = NestedSet.getAncestors(items, data).filter(item => item.deleted);
        //     return deletedAncestors.length;
        // },
        resetNewItemModal() {
            // this.$refs.newItemForm.resetFields();
            // this.newItemDialog.form.item.component = null;
            // this.newItemDialog.form.target = null;

            this.newItemDialog = {
                visibility: false,
                loading: false,
                form: {
                    item: {
                        title: '',
                        path: '',
                        hidden: false,
                        // A store serves its domain root through the item flagged as
                        // homepage; there is no menu item whose path is "/".
                        homepage: false,
                        component: null,
                        restriction: null,
                        page: null
                    },
                    position: 'after',
                    target: null,
                    sourceMenuItemId: null,
                },
            }
        },
        closeNewItemModal() {
            this.newItemDialog.visibility = false;
            // setTimeout(() => {
            //     // this.$refs.newItemForm.resetFields()
            //     this.$refs.newItemForm.clearValidate()
            // }, 0)
        },

        openSettingsModal() {
            this.settingsDialog.loading = true;
            this.settingsDialog.visibility = true;

            this.settingsDialog.form.name = this.form.name;
            this.settingsDialog.form.restriction = this.form.restriction || null;
            this.settingsDialog.form.memberTags = this.form.memberTags || [];

            if (this.settingsDialog.form.restriction === 'member-tags') {
                this.toggleSettingsDialogMemberRestriction(false);
            }
            this.settingsDialog.formSnapshot = this.snapshotOf(this.settingsDialog.form);

            setTimeout(() => {
                // this.$refs.settingsDialog.form.esetFields()
                this.$refs.settingsForm.clearValidate()
            })

            const fetchOptions = () =>
                Promise.all([
                    //- MemberTagApi.fetchList(this.activeCms.id)
                    //-     .then(tags => this.settingsDialog.tags = tags)
                ]);

            fetchOptions()
                .then(() => {
                    // TODO: rules

                    // setTimeout(() => (this.settingsDialog.loading = false), 0);
                    this.settingsDialog.loading = false;
                })
                .catch(err => {
                    this.settingsDialog.visibility = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Menu dependencies could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        toggleSettingsDialogMemberRestriction(value) {
            if (value === true) {
                // set members
                const i = this.restrictions.findIndex(el => el.key === 'member-tags')
                if (i >= 0) {
                    this.$set(this.restrictions[i], 'key', 'members')
                    this.$set(this.restrictions[i], 'value', 'members')
                    this.settingsDialog.form.restriction = 'members'
                }
            } else {
                // set member-tags
                const i = this.restrictions.findIndex(el => el.key === 'members')
                if (i >= 0) {
                    this.$set(this.restrictions[i], 'key', 'member-tags')
                    this.$set(this.restrictions[i], 'value', 'member-tags')
                    this.settingsDialog.form.restriction = 'member-tags'
                }
            }
        },
        async updateSettings() {
            this.settingsDialog.loading = true

            // this.setName(this.settingsDialog.form.name);
            // this.setRestriction(this.settingsDialog.form.restriction);

            let memberTags = []
            this.settingsDialog.form.memberTags.forEach(tag => {
                if (typeof tag === 'string' || tag instanceof String) {
                    memberTags.push({
                        id: uniqid('new:'),
                        name: tag,
                    })
                } else {
                    memberTags.push(tag)
                }
            })
            // this.setMemberTags(memberTags);

            // save menu / item positions
            // payload for the saveMenu mutation
            const payload = {
                id: this.id,
                name: this.settingsDialog.form.name,
                restriction: this.settingsDialog.form.restriction,
                memberTags,
            }

            if (!this.id) {
                payload.cms = { id: this.activeCms.id }
                payload.key = this.key
                payload.name = this.form.name
            }

            const menu = await this.menuStore.save(payload)
                .then(menu => {
                    this.menuStore.insertMenu(menu)
                    return menu
                })
                .catch(error => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Menu could not be saved.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(error)
                })

            this.settingsDialog.loading = false
            this.closeSettingsModal();
        },
        resetSettingsModal() {
            this.settingsDialog = {
                visibility: false,
                loading: false,
                form: {
                    name: '',
                    restriction: null,
                    memberTags: [],
                },
            }
        },
        closeSettingsModal() {
            this.settingsDialog.visibility = false;
        },

        changeCurrentItem(item) {
            // this.setCurrentItem(item)

            // get the correct route
            // const route = router.history.current.matched.find(route => route.components.default.name === 'Menu')
            //
            // if (route && item.id) {
            //     router.push(`${route.path}/${item.id}`)
            // }

            if (this.key && item.id) {
                // rerender tree (expand)
                this.expandAncestorItems(item.id);
                // this.uniqid = uniqid();

                const params = {
                    key: this.key,
                    id: item.id
                };
                router.push({ name: 'menu-item', params });
            }
        },
        handleWindowResize() {
            this.calculateContentWidth()
            this.$nextTick(this.updateTreeGripPosition)
            // this.calculateTreeWidth()
        },
        calculateContentWidth() {
            if (this.$refs.content) {
                this.contentWidth = 0
                this.$nextTick(() => {
                    const style = getComputedStyle(this.$refs.content)
                    this.contentWidth = this.$refs.content.clientWidth
                    this.contentWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                })
            }
        },
        startTreeResize(event) {
            if (event.button !== 0) return
            event.preventDefault() // otherwise the drag selects the text it passes over
            this.treeResize = { x: event.clientX, width: this.treeWidth }
            // Kill text selection / show the col-resize cursor everywhere while dragging.
            document.body.classList.add('tree-resizing')
        },
        onTreeResize(event) {
            if (!this.treeResize) return
            // A lost mouseup (released outside the window) leaves no buttons pressed.
            if (event.buttons === 0) {
                this.endTreeResize()
                return
            }
            this.treeWidth = clampTreeWidth(this.treeResize.width + event.clientX - this.treeResize.x)
            this.calculateContentWidth()
            this.$nextTick(this.updateTreeGripPosition)
        },
        endTreeResize() {
            if (!this.treeResize) return
            this.treeResize = null
            document.body.classList.remove('tree-resizing')
            setCookie(TREE_WIDTH_COOKIE_KEY, this.treeWidth)
            this.$nextTick(this.updateTreeGripPosition)
        },
        resetTreeWidth() {
            this.treeWidth = TREE_WIDTH
            setCookie(TREE_WIDTH_COOKIE_KEY, this.treeWidth)
            this.calculateContentWidth()
            this.$nextTick(this.updateTreeGripPosition)
        },
        // The grip is position:fixed so it holds the vertical centre of the viewport
        // at any scroll position. A transformed/filtered ancestor makes `fixed`
        // resolve against that ancestor instead of the viewport, so compute the grip
        // offset in px relative to its real containing block (grip.offsetParent).
        updateTreeGripPosition() {
            const handle = this.$refs.treeResizeHandle
            const grip = this.$refs.treeGrip
            const tree = this.$refs.tree
            if (!handle || !grip || !tree) return

            const handleRect = handle.getBoundingClientRect()

            // Centre the grip in the visible gap between the menu tree and the content
            // panel: midpoint of (tree right edge, content card left edge).
            const treeRight = tree.getBoundingClientRect().right
            const content = handle.nextElementSibling
            const card = content && content.firstElementChild
            let contentLeft
            if (card) {
                contentLeft = card.getBoundingClientRect().left
            } else if (content) {
                contentLeft = content.getBoundingClientRect().left + parseFloat(getComputedStyle(content).paddingLeft)
            } else {
                contentLeft = handleRect.right
            }
            const desiredX = (treeRight + contentLeft) / 2 // viewport x, centred in the gap

            // Centre the grip in the VISIBLE part of the divider: while the panel fits
            // in the viewport the grip sits at the panel's centre; once the panel is
            // taller than the viewport it rides the centre of the visible slice (i.e.
            // the viewport centre). Clamping to [top, bottom] keeps it off the void.
            const visibleTop = Math.max(handleRect.top, 0)
            const visibleBottom = Math.min(handleRect.bottom, window.innerHeight)
            const desiredY = (visibleTop + visibleBottom) / 2

            // offsetParent is null when `fixed` is viewport-relative, otherwise it is
            // the transformed ancestor the grip is actually positioned against.
            const containingBlock = grip.offsetParent
            const origin = containingBlock
                ? containingBlock.getBoundingClientRect()
                : { left: 0, top: 0 }

            this.treeGripLeft = desiredX - origin.left
            this.treeGripTop = desiredY - origin.top
        },
        // The route view slides in with a CSS transform (App.vue "slide-fade", 350 ms;
        // the sidebar and other containers transition transforms too). While a
        // transform runs on an ancestor the grip's `fixed` box is positioned against
        // that ancestor, and a grip placed during the slide keeps those offsets once
        // the transform is gone: it then sits far from the gutter. The menu usually
        // loads before the slide ends, so every placement above could fall into that
        // window. A finished transform transition anywhere on the page may have
        // changed the grip's containing block, so place it again.
        onTransformTransitionEnd(event) {
            if (event.propertyName !== 'transform') return
            this.$nextTick(this.updateTreeGripPosition)
        },
        // Recompute the grip position whenever the panel's height changes (items
        // loading, expand/collapse, selecting an item grows the content form) so the
        // "centre within the card" case stays correct without a scroll/resize nudge.
        observeTreeResize() {
            if (typeof ResizeObserver === 'undefined') return
            const handle = this.$refs.treeResizeHandle
            if (!handle || !handle.parentElement) return
            if (this.treeResizeObserver) this.treeResizeObserver.disconnect()
            this.treeResizeObserver = new ResizeObserver(() => this.updateTreeGripPosition())
            this.treeResizeObserver.observe(handle.parentElement)
        },
        checkConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.settingValues;
            const enabledExtensions = this.enabledExtensions;
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
        // NOTE: does not work propperly
        // calculateTreeWidth() {
        //     if (this.$refs.tree) {
        //         this.treeWidth = 0
        //         this.$nextTick(() => {
        //             const style = getComputedStyle(this.$refs.tree)
        //             this.treeWidth = this.$refs.tree.clientWidth
        //             this.treeWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
        //         })
        //     }
        // },

        async hideItem(item) {
            if (!item.id || _.startsWith(item.id, 'new:')) return

            this.menuStore.markItemAsHidden(item);

            // payload for the saveMenu mutation
            const payload = {
                id: this.id,
                menuItems: [{
                    id: item.id,
                    hidden: true,
                }]
            }

            const menu = await this.menuStore.save(payload)
                // .then(menu => {
                //     this.$notify.success({
                //         title: this.$t('Menu Item hidden successfully!'),
                //         iconClass: 'fas el-icon-fa-check',
                //         position: 'bottom-left',
                //         customClass: 'dark',
                //         duration: 8000,
                //     })
                // })
                .catch(error => {
                    this.menuStore.unmarkItemAsHidden(item);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Menu Item could not be hidden.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(error)
                })
        },
        // 'menu/form/unmarkItemAsHidden',
        async unhideItem(item) {
            if (!item.id || _.startsWith(item.id, 'new:')) return

            this.menuStore.unmarkItemAsHidden(item);

            // payload for the saveMenu mutation
            const payload = {
                id: this.id,
                menuItems: [{
                    id: item.id,
                    hidden: false,
                }]
            }

            const menu = await this.menuStore.save(payload)
                // .then(menu => {
                //     this.$notify.success({
                //         title: this.$t('Menu Item made visible successfully!'),
                //         iconClass: 'fas el-icon-fa-check',
                //         position: 'bottom-left',
                //         customClass: 'dark',
                //         duration: 8000,
                //     })
                // })
                .catch(error => {
                    this.menuStore.markItemAsHidden(item);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Menu Item could not be made visible.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(error)
                })
        },

        openDeleteDialog(item) {
            if (!item.id || _.startsWith(item.id, 'new:')) return

            if (MenuApi.noDeleteDialog() === 'true') {
                this.deleteItem(item)
            } else {
                this.deleteDialog.visibility = true;
                this.deleteDialog.item = item;
            }
        },
        closeDeleteDialog() {
            this.deleteDialog.visibility = false;
            this.deleteDialog.loading = false;
            this.deleteDialog.item = undefined;
        },

        // 'menu/form/markItemAsDeleted',
        async deleteItem(item) {
            if (!item.id || _.startsWith(item.id, 'new:')) return

            let items = _.get(this.form, 'menuItems', []);
            const backup = _.cloneDeep(items)

            const remove = (tree, item) => {
                const i = tree.findIndex(el => el.id === item.id);
                if (i >= 0) tree.splice(i, 1);
                tree.forEach(el => {
                    if (el.children && el.children.length) {
                        el.children = remove(el.children, item);
                    }
                });
                return tree
            };

            const tree = remove(this.tree, item)
            items = NestedSet.flattenTree(tree)

            // payload for the saveMenu mutation
            const payload = {
                id: this.id,
                menuItems: [...(items || []).map(el => ({
                    id: el.id,
                    _lft: el._lft,
                    _rgt: el._rgt,
                })), {
                    id: item.id,
                    deleted: true,
                }]
            }

            if (NestedSet.hasChildren(item)) {
                items = NestedSet.getChildren(this.form.menuItems, item)
                items.forEach(item => payload.menuItems.push({
                    id: item.id,
                    deleted: true,
                }))
            }

            if (!this.deleteDialog.visibility) {
                this.menuStore.setState({ path: 'form.menuItems', value: items })
            }

            if (this.deleteDialog.remember) {
                MenuApi.noDeleteDialog(true)
            }

            this.deleteDialog.loading = true;
            const menu = await this.menuStore.save(payload)
                .then(menu => {
                    this.menuStore.insertMenu(menu)
                    this.closeDeleteDialog();
                })
                .catch(error => {
                    this.menuStore.setState({ path: 'form.menuItems', value: backup })

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Menu Item could not be deleted.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(error)
                })
                .finally(() => {
                    this.deleteDialog.loading = false;
               });

            apolloClient.cache.reset();

            // refetch menu options
            this.fetchMenuOptions(this.activeCms.id),
            this.fetchMenuItemPaths({ id: this.activeCms.id, key: this.key })
        },

        hasChildren(item) {
            return NestedSet.hasChildren(item);
        },
        openDuplicateDialog(item) {
            if (!item.id || _.startsWith(item.id, 'new:')) return

            this.duplicateDialog.item = item;
            this.duplicateDialog.includeChildren = this.hasChildren(item);
            this.duplicateDialog.visibility = true;
        },
        closeDuplicateDialog() {
            this.duplicateDialog.visibility = false;
            this.duplicateDialog.loading = false;
            this.duplicateDialog.includeChildren = false;
            this.duplicateDialog.item = undefined;
        },
        // Same kebab-case + numeric-suffix scheme as the "Add Menu Item" title
        // watcher (line ~648), pulled out here so duplicated items get unique
        // paths too instead of colliding with the source item's path.
        generateUniquePath(title) {
            const requestedPath = _.kebabCase(title);
            let path = requestedPath;

            let i = 0;
            while (this.usedPaths.indexOf(`/${path}`) >= 0) {
                ++i;
                path = `${requestedPath}-${i}`;
            }

            return `/${path}`;
        },
        // Clones one source item's content via CP_CloneMenuItem (the same
        // mutation the "Copy content from" dialog field uses) and returns the
        // newly created item. `component`/`page` are only relevant to the
        // non-clone creation path server-side - the clone derives its page
        // content from sourceMenuItemId - but MenuApi.cloneMenuItem() strips
        // `component` before sending regardless, so a sane default is enough.
        //
        // No targetMenuItemId/position is passed here on purpose: CP_CloneMenuItem's
        // own into/before/after placement never shifts the existing items' _lft/_rgt
        // to make room for the new one, so anywhere other than appending after the
        // very last item in the whole menu produces an overlapping/invalid nested
        // set - which is why "duplicate with sub items" wasn't preserving the tree.
        // Instead we let the new item land wherever the backend's default creation
        // puts it, clone as many nodes as needed this way, then reposition all of
        // them at once client-side via saveTree() - the exact same nested-set math
        // (and the exact same UpdateMenu mutation) the "Add Menu Item" dialog's
        // non-clone path already relies on. The backend clones the source item's
        // translations by itself as part of CP_CloneMenuItem, so there is nothing
        // left to do for those here.
        async cloneMenuItemContent(node, titleSuffix) {
            const defaultType = _.find(this.menuOptions.itemType.items, 'default');
            const id = uniqid('new:');
            const title = titleSuffix ? `${node.title} ${titleSuffix}` : node.title;

            const menuItem = {
                id,
                title,
                path: this.generateUniquePath(title),
                hidden: node.hidden,
                // Never duplicate the homepage flag - a store can only have one start page.
                homepage: false,
                component: defaultType,
                restriction: node.restriction || null,
                page: {
                    id,
                    view: _.get(defaultType, 'view'),
                    extension: _.get(defaultType, 'extension') || null
                }
            };

            const menu = await MenuApi.cloneMenuItem({
                sourceMenuItemId: parseInt(node.id),
                menuId: parseInt(this.id),
                menuItem
            });

            this.menuStore.insertMenu(menu);

            const clonedItems = _.cloneDeep(menu.menuItems || []).sort((a, b) => a.id - b.id);
            return clonedItems[clonedItems.length - 1];
        },
        async duplicateItem() {
            const item = this.duplicateDialog.item;
            if (!item) return

            this.duplicateDialog.loading = true;

            try {
                const items = _.get(this.form, 'menuItems', []);

                // Snapshot the tree before any clone call touches state, so the
                // duplicated (sub)tree can be inserted into a known-good structure
                // afterwards instead of wherever the backend happened to drop each
                // freshly cloned item.
                const originalTree = _.cloneDeep(this.tree);

                let sourceChildren = [];
                if (this.duplicateDialog.includeChildren && this.hasChildren(item)) {
                    const descendants = NestedSet.getChildren(items, item);
                    const subtree = NestedSet.createTree([item, ...descendants], item._lft - 1, item._rgt + 1);
                    sourceChildren = _.get(subtree, '[0].children') || [];
                }

                // Clone every node's content - order/target doesn't matter here, real
                // positioning happens once, below - rebuilding the source (sub)tree's
                // exact shape with each node replaced by its freshly cloned copy.
                const cloneTree = async sourceNodes => {
                    const clones = [];
                    for (const sourceNode of sourceNodes) {
                        const newNode = await this.cloneMenuItemContent(sourceNode);
                        newNode.children = await cloneTree(sourceNode.children || []);
                        clones.push(newNode);
                    }
                    return clones;
                };

                const newRoot = await this.cloneMenuItemContent(item, this.$t('(Copy)'));
                newRoot.children = await cloneTree(sourceChildren);

                // Insert the duplicated (sub)tree right after the source item, at the
                // same level, into the untouched original structure.
                const insertAfter = (nodes, targetId, newNode) => {
                    for (let i = 0; i < nodes.length; i++) {
                        if (nodes[i].id === targetId) {
                            nodes.splice(i + 1, 0, newNode);
                            return true;
                        }
                        if (nodes[i].children && insertAfter(nodes[i].children, targetId, newNode)) return true;
                    }
                    return false;
                };

                if (!insertAfter(originalTree, item.id, newRoot)) originalTree.push(newRoot);

                const menu = await this.saveTree(originalTree);
                if (!menu) return;

                apolloClient.cache.reset();
                this.fetchMenuOptions(this.activeCms.id);
                this.fetchMenuItemPaths({ id: this.activeCms.id, key: this.key });

                this.changeCurrentItem(newRoot);
                this.closeDuplicateDialog();
            } catch (error) {
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Menu Item could not be duplicated.'),
                    iconClass: 'fas el-icon-fa-xmark',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
                console.error(error)
            } finally {
                this.duplicateDialog.loading = false;
            }
        },

        setInitializedFlag(flag) {
            this.menuStore.setFormInitialized(flag);
        },
        updateItemTypeOptionsLoading(value) {
            this.menuStore.updateItemTypeOptionsLoading(value);
        },
        insertItemTypeOptions(itemTypes) {
            this.menuStore.insertItemTypeOptions(itemTypes);
        },
        expandAll() {
            this.menuStore.expandAll();
        },
        collapseAll() {
            this.menuStore.collapseAll();
        },
        setName(name) {
            this.menuStore.setFormName(name);
        },
        setRestriction(restriction) {
            this.menuStore.setFormRestriction(restriction);
        },
        setMemberTags(memberTags) {
            this.menuStore.setFormMemberTags(memberTags);
        },
        moveItem(payload) {
            this.menuStore.moveFormItem(payload);
        },
        updateSectionOptionsLoading(value) {
            this.pageStore.updateSectionOptionsLoading(value);
        },
        insertSectionOptions(sections) {
            this.pageStore.insertSectionOptions(sections);
        },
        activateTab(item) {
            return useSetupStore().activateTab(item);
        },
        fetchMenu(payload) {
            return this.menuStore.fetchMenu(payload);
        },
        create(menu) {
            return this.menuStore.create(menu);
        },
        update(menu) {
            return this.menuStore.update(menu);
        },
        fetchMenuItem(id) {
            return this.menuStore.fetchMenuItem(id);
        },
        fetchMenuItemPaths(payload) {
            return this.menuStore.fetchMenuItemPaths(payload);
        },
        fetchMenuOptions(cmsID) {
            return this.pageStore.fetchMenuOptions(cmsID);
        },
        fetchTagOptions(cmsID) {
            return this.pageStore.fetchTagOptions(cmsID);
        },
        fetchFileTagOptions(cmsID) {
            return this.pageStore.fetchFileTagOptions(cmsID);
        },
        // extensions
        fetchEventCategoryOptions(cmsID) {
            return this.pageStore.fetchEventManagerCategoryOptions(cmsID);
        },
        fetchShopCategoryOptions(shopID) {
            return this.pageStore.fetchShopCategoryOptions(shopID);
        },
        fetchPropertyOptions(shopID) {
            return this.pageStore.fetchShopPropertyOptions(shopID);
        },
        fetchShopTagOptions(shopID) {
            return this.pageStore.fetchShopTagOptions(shopID);
        },
        fetchMarketingCampaignOptions(cmsID) {
            return this.pageStore.fetchMarketingCampaignOptions(cmsID);
        },
        fetchSubscriptionTopicOptions(cmsID) {
            return this.pageStore.fetchNewsletterSubscriptionTopicOptions(cmsID);
        },
        fetchMemberTagOptions(cmsID) {
            return this.pageStore.fetchRestrictedAreaMemberTagOptions(cmsID);
        }
    },
    beforeRouteEnter(to, from, next) {
        let cms = useSetupStore(pinia).activeCms;
        let menus = _.get(cms, 'config.template.menus') || [];
        menus = _.orderBy(menus, 'position');

        const keys = _.map(menus, 'key');

        //>>> redirect if menu not active
        // if (to.params.key != '') {
        //     const designs = cms.config.template.settings.find(setting => setting.key === "design")

        //     if (designs) {

        //         let activeMenu = menus.find(menu => menu.key === to.params.key)

        //         const block = designs.blocks.find(block => block.key === activeMenu.key)
        //         if (block !== undefined) {

        //             let valid = true

        //             let settings = {}
        //             for (let settingItem of cms.settings) {
        //                 settings[settingItem.key] = settingItem.value
        //             }

        //             try {
        //                 const conditions = block.conditions
        //                 if (conditions && conditions.length) {
        //                     conditions.forEach(o => {
        //                         if (valid === false) return

        //                         const { type, condition } = o
        //                         switch (type) {
        //                             case 'eval':
        //                                 valid = eval(condition)
        //                                 break;

        //                             default:
        //                                 valid = false
        //                         }
        //                     })
        //                 }
        //             } catch (error) {
        //                 // eslint-disable-next-line
        //                 console.error(error);
        //                 valid = false
        //             }
        //             if (!valid) next({ name: 'menu-form', params: { key: '' } });
        //         }
        //     }


        // }
        //<<<

        if (!keys.length) next({ name: 'dashboard' });
        else {
            // redirect if necessary
            let key = _.get(to, 'params.key');

            // if (!key || key === '#' || !keys.includes(key)) {
            //     key = keys[0];
            //     next({ name: 'menu-form', params: { key } });
            // } else {
            //     next();
            // }

            next(vm => {
                const settings = _.get(vm.activeCms, 'config.template.settings') || [];

                if (vm.tabs.find(tab => tab.key === key)) return next()
                else if (vm.tabs.length) return next({ name: 'menu-form', params: { key: vm.tabs[0].key } })
                else return next({ name: 'dashboard' })
            })
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name === 'menu-form' || (to.name === 'menu-item' && to.params.id === undefined)) {
            this.loading = true;
            this.setInitializedFlag(false);
            // timeout is for the loading animation
            setTimeout(() => {
                this.initialize(to.params.key)
            }, 150);
        }

        const fixedOffset = 0;

        const onScroll = () => {
            if (window.pageYOffset.toFixed() <= fixedOffset) {
                window.removeEventListener('scroll', onScroll);
                next();
            }
        }
        window.addEventListener('scroll', onScroll);
        onScroll();

        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: fixedOffset
        });
    },
    beforeRouteLeave(to, from, next) {
        next();

        // setTimeout(() => {
        // }, 300);

        // TODO: add reset action
        // see event form

        const menuTemplate = {
            name: '',
            key: '',
            menuItems: []
        };
        useMenuStore(pinia).insertMenu(menuTemplate);
        useMenuStore(pinia).resetUI();

        usePageStore(pinia).reset();
    },
    mounted() {
        this.initialize();

        window.addEventListener('resize', this.handleWindowResize)
        window.addEventListener('mousemove', this.onTreeResize)
        window.addEventListener('mouseup', this.endTreeResize)
        // Capture phase so inner scroll containers also keep the grip centred.
        window.addEventListener('scroll', this.updateTreeGripPosition, true)
        document.addEventListener('transitionend', this.onTransformTransitionEnd, true)
        document.addEventListener('keydown', this.handleKeyDown)
        this.calculateContentWidth()
        this.$nextTick(this.updateTreeGripPosition)
        this.$nextTick(this.observeTreeResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize)
        window.removeEventListener('mousemove', this.onTreeResize)
        window.removeEventListener('mouseup', this.endTreeResize)
        window.removeEventListener('scroll', this.updateTreeGripPosition, true)
        document.removeEventListener('transitionend', this.onTransformTransitionEnd, true)
        document.removeEventListener('keydown', this.handleKeyDown)
        document.body.classList.remove('tree-resizing')
        if (this.treeResizeObserver) this.treeResizeObserver.disconnect()
    }
};
</script>

<style lang="sass" scoped>

.menu
    .el-card
        min-height: 125px
    :deep() .center-x-y.take-max-height section.has-text-centered
        .title
            font-size: 4rem
        .subtitle
            font-size: 1rem
            font-weight: normal

    .empty-menu .flex-row
        margin-top: 20px

    .menu-items
        display: flex
        // The tree column is resized via an inline flex-basis bound to treeWidth;
        // override the shared _tree.sass min/max so the dragged width always wins.
        .tree
            flex-grow: 0
            flex-shrink: 0
            min-width: 240px
            max-width: none
            // A title too long for the column truncates with an ellipsis; widening
            // the column (drag the grip) reveals the rest.
            .custom-tree-node
                min-width: 0
            .grow
                margin-right: 0
                overflow: hidden
                white-space: nowrap
                text-overflow: ellipsis
    // The gutter is the full-height drag zone; the visible grip is position:fixed so
    // it sits in the gap at the vertical centre of the viewport and is discoverable.
    .tree-resize-handle
        flex: none
        width: 16px
        align-self: stretch
        cursor: col-resize
        display: flex
        justify-content: center
        position: relative
        z-index: 2
        &__grip
            // Fixed so it holds the vertical centre of the viewport; top/left are bound
            // reactively (treeGripTop / treeGripLeft) and the translate re-centres the
            // pill on that point.
            position: fixed
            transform: translate(-50%, -50%)
            z-index: 10
            display: flex
            align-items: center
            justify-content: center
            width: 8px
            height: 56px
            border-radius: 6px
            background: $--border-color-base
            box-shadow: 0 0 0 4px #fff
            color: #fff
            font-size: 11px
            cursor: col-resize
            transition: background .15s, box-shadow .15s
            i
                pointer-events: none
        &:hover &__grip,
        &--active &__grip
            background: $--color-primary
    .content
        flex-basis: 100%
        flex-grow: 1
        padding-left: 20px
        min-width: 0
    .orphan
        color: $--color-warning

    .new-page-dialog :deep() .el-dialog
        // max-width: 620px
        .modal-body > .el-form-item:last-child
            margin-bottom: 0
        .target-position
            display: flex
            .position
                padding-right: 10px
                flex-shrink: 0
                :deep() .el-switch
                    margin-top: -2px
                    position: relative
                    .el-switch__core
                        background-color: $--color-primary
                    .el-switch__label
                        color: $--font-color-disabled-base
                        &.is-active
                            color: $--color-primary

.menu-items .tree .flex-row
    margin-bottom: 1rem

.context-icon
    font-size: 2.2rem
    text-align: center
    margin-bottom: 1rem
    color: $--color-primary
    small
        font-size: 1rem
        display: block

#sticky-content-container
    .sticky-stuff
        padding: 15px 0
        z-index: 1

.custom-tree-node
    .icon
        width: 15px
        margin-right: 4px
        text-align: center
        &.homepage
            color: $--color-success
            &.restricted
                color: $--color-warning
            // & + span.grow
            //     color: $--shop-color-primary
        &.folder
            // color: $--color-warning
            color: $color-grey-text
        &.file
            color: $color-grey-text

.el-button.full-width
    width: 100%


// Hint under the start-page switch. Inside an el-form-item the inherited
// line-height is 36px, so it has to be stated explicitly - same values the other
// settings forms use for their .help text.
.new-item-dialog__help
    margin-top: 4px
    font-size: 12px
    color: var(--color-text-muted, #909399)
    line-height: 1.4

</style>
